import { toast } from '@navi/web-ui/lib/primitives/Toast';
import axiosInstance, { ApiKeys, getApiUrl, getErrorMessage, logError } from 'src/utils/ApiHelper';
import { PaymentPayload } from '../interfaces/Payments.type';
import { DeepLinkRequest } from '@cp/src/constants/Common.constants';

export const generatePaymentLink = (
  loanaccountnumber: string,
  customerreferenceid: string,
  payload: PaymentPayload,
  setLoading: React.Dispatch<React.SetStateAction<boolean>>
) => {
  axiosInstance
    .post(getApiUrl(ApiKeys.GENERATE_PAYMENT_LINK), payload, {
      headers: {
        loanaccountnumber,
        customerreferenceid,
        includeInUptimeMetrics: true
      }
    })
    .then(res => {
      window?.navigator?.clipboard
        ?.writeText(res?.data)
        .then(() => {
          toast('Payment link copied', { type: 'success' });
        })
        .catch(err => {
          logError(err);
        });
    })
    .finally(() => setLoading(false));
};

export const sendPaymentLink = (
  loanaccountnumber: string,
  customerreferenceid: string,
  payload: PaymentPayload,
  setLoading: React.Dispatch<React.SetStateAction<boolean>>,
  successCallback?: () => void,
  failureCallback?: (error) => void
) => {
  axiosInstance
    .post(getApiUrl(ApiKeys.SEND_PAYMENT_LINK), payload, {
      headers: {
        loanaccountnumber,
        customerreferenceid,
        donotHandleError: true,
        includeInUptimeMetrics: true
      }
    })
    .then(() => {
      toast('Payment link sent', { type: 'success' });
      successCallback && successCallback();
    })
    .catch(error => {
      failureCallback && failureCallback(error?.response?.data);
      toast(getErrorMessage(error), { type: 'error' });
    })
    .finally(() => setLoading(false));
};

export const sendDeepLink = (
  payload: DeepLinkRequest,
  setLoading: React.Dispatch<React.SetStateAction<boolean>>,
  successCallback?: () => void,
  failureCallback?: (error) => void
) => {
  axiosInstance
    .post(getApiUrl(ApiKeys.SEND_DEEPLINK), payload, {
      headers: {
        donotHandleError: true
      }
    })
    .then(() => {
      toast('Link sent', { type: 'success' });
      successCallback && successCallback();
    })
    .catch(error => {
      failureCallback && failureCallback(error?.response?.data);
      toast(getErrorMessage(error), { type: 'error' });
    })
    .finally(() => setLoading(false));
};

export const getForeclosureAmount = (lan: string, preclosureDate: string) => {
  const url = getApiUrl(ApiKeys.GET_FORECLOSURE_AMOUNT, { lan }, { preclosureDate });
  return axiosInstance.get(url, { headers: { includeInUptimeMetrics: true } });
};
